export const GET_ACCOUNTS = "GET_ACCOUNTS"
export const ADD_ACCOUNT = "ADD_ACCOUNT"
export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT"
export const DELETE_ACCOUNT = "DELETE_ACCOUNT"
export const ERROR_ACCOUNT = "ERROR_ACCOUNT"
